import React from 'react';
import { isObservableObject } from 'mobx';
import { isSome } from 'core/utils';
import _ from 'lodash';

function PrintObjectValues(obj) {
	let retVal = {};
	for (var key in obj) {
		if (typeof obj[key] === 'object' || isObservableObject(obj[key])) {
			Object.assign(retVal, PrintObjectValues(obj[key]));
		} else {
			retVal[key] = obj[key];
		}
	}
	return retVal;
}

function DisplayErrorTemplate(errors) {
	return isSome(errors) ? (
		<ul>
			{_.map(PrintObjectValues(errors), (val, key) => (
				<li key={key}>
					{key} : {val}
				</li>
			))}
		</ul>
	) : null;
}

export default DisplayErrorTemplate;
